import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import { Stack, Tabs, styled } from '@mui/material';
import { NavLink, useLocation } from 'react-router';
import { useMemo } from 'react';
import { ROUTES, getRouteTitle } from '../../../../constants/RouteNameMapping';
import { kpiRequestsCountStateJ } from '../../../../services/state/KPI/KPIRequestsStateJ';
import { KPIRequestStatus } from '../../../../data-models/kpi-requests.data-model';
import { CountBadge, KPITabSx } from './TabComponents';
import { useAtomValue } from 'jotai';

export const CustomTabPanel = styled(TabPanel)`
  padding: 0;
  height: 100%;
`;

export function KPIRequestsTabs() {
  const { pathname } = useLocation();
  const requestCount = useAtomValue(kpiRequestsCountStateJ);

  const tabs = useMemo(() => {
    const toSendPath = `/${ROUTES.KPI}/${ROUTES.KPI_REQUESTS}`;
    return [
      {
        path: toSendPath,
        title: (
          <Stack direction='row'>
            To Send
            <CountBadge
              badgeContent={requestCount[KPIRequestStatus.NotSent]}
              active={pathname === toSendPath}
            />
          </Stack>
        ),
      },
      {
        path: `/${ROUTES.KPI}/${ROUTES.KPI_REQUESTS}/${ROUTES.KPI_REQUESTS_IN_PROGRESS}`,
        title: getRouteTitle(ROUTES.KPI_REQUESTS_IN_PROGRESS),
      },
      {
        path: `/${ROUTES.KPI}/${ROUTES.KPI_REQUESTS}/${ROUTES.KPI_REQUESTS_ARCHIVED}`,
        title: getRouteTitle(ROUTES.KPI_REQUESTS_ARCHIVED),
      },
    ];
  }, [pathname, requestCount]);

  return (
    <Tabs variant='scrollable' scrollButtons='auto' value={pathname}>
      {tabs.map((t) => (
        <Tab
          component={NavLink}
          key={t.path}
          value={t.path}
          label={t.title}
          sx={KPITabSx}
          to={{ pathname: `${t.path}` }}
        />
      ))}
    </Tabs>
  );
}
